import axios from '@/axios.config.js';

class QuestionBankService {
    systemToAPILabel(entity) {
        return {
            name: entity.name,
        }
    }

    systemToAPIQuestion(entity) {
        return {
            labels: entity.labels,
            content: entity.content,
            type: entity.type,
            explanation: entity.explanation,
            multi_media: entity.multi_media,
            answer_multi_media: entity.answer_multi_media,
            options: entity.options,
        }
    }

    listLabels(cancelToken, query, page, count) {
        const params = {};

        if (query)
            params['query'] = query

        if (page)
            params['page'] = page

        if (count)
            params['count'] = count

        return axios
            .get(`question-banks/labels`, {
                params: params,
                cancelToken: cancelToken.token
            })
            .then(response => {
                return response.data
            });
    }

    createLabel(cancelToken, label) {
        return axios
            .post('question-banks/labels', this.systemToAPILabel(label), {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateLabel(cancelToken, label) {
        return axios
            .patch(`question-banks/labels/${label.id}`, this.systemToAPILabel(label), {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteLabel(cancelToken, labelId) {
        return axios
            .delete(`question-banks/labels/${labelId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listQuestions(cancelToken, query, page, count) {
        const params = {};

        if (query)
            params['query'] = query

        if (page)
            params['page'] = page

        if (count)
            params['count'] = count

        return axios
            .get('question-banks/questions', {
                params: params,
                cancelToken: cancelToken.token
            })
            .then(response => {
                return response.data;
            });
    }

    createQuestion(cancelToken, question) {
        return axios
            .post('question-banks/questions', this.systemToAPIQuestion(question), {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    importQuestion(cancelToken, fileId) {
        return axios
            .post(`question-banks/questions/!import`, fileId, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateQuestion(cancelToken, question) {
        return axios
            .patch(`question-banks/questions/${question.id}`, this.systemToAPIQuestion(question), {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteQuestion(cancelToken, questionId) {
        return axios
            .delete(`question-banks/questions/${questionId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listReviewers(cancelToken) {
        return axios
            .get('question-banks/questions-reviewers', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    createReviewer(cancelToken, reviewer) {
        return axios
            .post('question-banks/questions-reviewers', reviewer, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateReviewer(cancelToken, reviewerId, reviewer) {
        return axios
            .patch(`question-banks/questions-reviewers/${reviewerId}`, reviewer, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteReviewer(cancelToken, reviewerId) {
        return axios
            .delete(`question-banks/questions-reviewers/${reviewerId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listBankLogs(cancelToken) {
        return axios
            .get('question-banks/audit-logs', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    listReviewerLogs(cancelToken, reviewerId) {
        return axios
            .get(`question-banks/questions-reviewers/${reviewerId}/audit-logs`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

}

export default new QuestionBankService();